<div class="alert alert-danger text-left" [hidden]="!error()">
  {{ error() }}
</div>

<wl-busy [show]="isSaving()"></wl-busy>

<div class="actions-row">
  <button pButton type="button" class="atlas-btn atlas-btn-secondary tall" (click)="cancel()" [disabled]="isSaving()" icon="pi pi-ban">
    {{ 'common.cancel' | translate | titlecase }}
  </button>

  <button
    *ngIf="showSave()"
    pButton
    type="button"
    class="atlas-btn atlas-btn-primary tall ml-10"
    (click)="save()"
    [disabled]="isSaveDisabled() || isSaving()"
  >
    <i class="pi pi-save"></i>
    <span [hidden]="isSaving()">{{ saveLabel() | translate | titlecase }}</span>
    <span [hidden]="!isSaving()">{{ 'common.saving' | translate | titlecase }}</span>
  </button>
</div>
